<template>
	<div id="ExlusiveContent" :class="{ active: ExlusiveContentActive }">
		<div class="content-container">
			<div class="content">
				<div class="section_header">
					<!-- <h3>Your Season Ticket Service Representative</h3> -->


					<div class="close" @click="togglePlay()" @click.prevent="(e) => $emit('ExlusiveContentHide', 'hide')">
						<img src="@/assets/images/icons/close.svg" />
					</div>
				</div>

				<div class="msg-container">
					<div class="message">
						<!--  -->
						<vueVimeoPlayer
						v-if="$store.getters['dom/isMobile']"
						@ready="onReady"
						:player-height="250"
						:player-width="350"
						ref="player"
						:video-url="videoURL"
						:options="options"

						></vueVimeoPlayer>
						<vueVimeoPlayer
						v-else-if="$store.getters['dom/isTablet']"
						@ready="onReady"
						:player-height="550"
						:player-width="650"
						ref="player"
						:video-url="videoURL"
						:options="options"

						></vueVimeoPlayer>

						<vueVimeoPlayer
						v-else
						@ready="onReady"
						:player-height="height"
						:player-width="width"
						ref="player"
						:video-url="videoURL"
						:options="options"

						></vueVimeoPlayer>
						<!-- <iframe
						src="https://player.vimeo.com/video/757310680?h=7fed5f5665" width="1040" height="660" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> -->
					</div>


				</div>

			</div>


		</div>

	</div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

// import axios from "axios";

export default {
	name: "ExlusiveContent",
	props: ["ExlusiveContentActive"],
	emits: ["ExlusiveContentHide"],
	components: {
		vueVimeoPlayer,
	},
	data() {
		return {
			videoID: "769038324",
			videoURL: "https://player.vimeo.com/video/769038324?h=6669acd5fc",
			// videoID: "763873086",
			// videoURL: "https://player.vimeo.com/video/763873086?h=4dcfc0ccb5",
			height: 600,
			responsive:true,
			width:1000,
			autoPause: true,
			options: {
				// autoplay: true,
				// responsive: true,

			},

			playerReady: false,
			playerActiveClass: "",
			muted: true,
			// muteVisible: true,
		};

	},
	setup() {
		const store = useStore();

		// State
		const state = reactive({

			purl: computed(() => store.getters["purl/getAccount"]),

		});

		return { ...toRefs(state), store };
	},

	mounted() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		window.addEventListener("resize", () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		});


	},
	methods: {
		togglePlay() {
			this.$refs.player.pause();
		},
		onReady() {
			this.playerReady = true
		},
	},

};
</script>

<style lang="scss" scoped>
#ExlusiveContent {
	background: rgba(0, 0, 0, 0.8);
	position: fixed;
	top: 0px;
	left: 0;
	width: 100vw;
	height: calc(var(--vh, 1vh) * 100);
	max-height: 0;
	opacity: 0;
	transition: all 0.5s ease-in-out;
	overflow: hidden;
	z-index: 1000;
	&.active {
		max-height: calc(var(--vh, 1vh) * 100);
		opacity: 1;
		transition: all 0.5s ease-in-out;
	}
	.content-container {
		display: flex;
		flex-direction:column;
		justify-content: center;
		align-items: center;
		height: 100%;
		// width: 100%;
		// background: rgba(255,255,255,0.4);
	}
	.content {
		position: relative;
		// min-height: 319px;
		// width: 780px;
		// height: 319px;
		width:auto;
		border-radius:4px;

		// &.suite{
		// 	background: #1f5733;
		// }
		// &.sth{
		// background: #0B2255;
		// }
		// &.premier{
		// 	background: #1f5733;
		// }
		color:white;
		// background-image: linear-gradient(180deg, #ffffff 0%, #e2e2e2 100%);
		// box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.5);
		@include media-breakpoint-down(sm) {
			// padding: 39px 25px 45px 25px;
			width: 348px;
		}
		.section_header{
			display: flex;

			padding: 15px 20px;
			// flex-direction:column;
			justify-content: space-between;
			// align-items: center;
			h3{
				color:white;
				font-family: 'Verlag Condensed Book';
				font-style: normal;
				font-weight: 400;
				font-size: 20px;
				line-height: 100%;
				margin-bottom:0px;
				display: flex;
				align-items: center;
				text-transform: uppercase;
			}
		}
		.close {
			position: absolute;
			top: 5px;
			right: 5px;
			height: fit-content;
			width: fit-content;
			cursor: pointer;
			@include media-breakpoint-down(sm) {
				top: 5px;
				right: 5px;
			}
		}
		.msg-container{
			display: flex;
			flex-direction:row;
			@include media-breakpoint-down(sm) {
				flex-direction:column;
			}
			.image-container{

				img{
					height: 319px;
					border-right:3px solid #0E3386;
					// width: 498px;
					// height: 350px;
					// border-radius: 0px 4px 4px 0px;
				}
				.suite{
					border-right:3px solid #dcb363;
				}
				.sth{
					border-right:3px solid #0E3386;
				}
				.premier{
					border-right:3px solid #dcb363;
				}
			}
		}
		.message{
			display:flex;
			flex-direction:row;
			// gap:30px;
			justify-content: center;
			align-items: center;
			@include media-breakpoint-down(sm) {
				flex-direction:column;
				width: 348px;
			}

			// background-color:white;
			// padding:60px;
			h3{
				font-family: 'BoxedRegular-Bold';
				font-style: normal;
				font-weight: 700;
				font-size: 35px;
				line-height: 42px;
				// margin:60px 6;
				/* Black */

				color: #1D1D1D;
			}

		}
	}


}
</style>
